/**
 * Parses a date string in YYYY-MM-DD format as a local date
 * instead of UTC to avoid timezone offset issues
 * @param dateString - Date string in YYYY-MM-DD format
 * @returns Date object with local timezone interpretation
 */
export const parseDateAsLocal = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);

  return new Date(year, month - 1, day);
};
